import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-left-arrow",
  "use": "icon-left-arrow-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-left-arrow\"><path d=\"M6.486 7.987l5.948 6.197c.19.19.19.38 0 .57l-1.069 1.104c-.19.19-.38.19-.57 0L3.53 8.272a.385.385 0 0 1-.106-.285c0-.119.035-.214.106-.285L10.796.116c.166-.166.356-.154.57.036l1.068 1.068c.19.19.19.38 0 .57L6.486 7.987z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol